import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { OverlayLabelContainer, OverlayLabelText } from './styled-components';

interface OverlayLabelProps {
  label?: string;
  top?: string;
}

export const OverlayLabel: FC<OverlayLabelProps> = ({ label, top = '40%' }) => {
  const { t } = useTranslation('purchase');
  const defaultLabel = t('trading_system.assets.futures.overlay_label', {
    defaultValue: 'Coming Soon',
  });
  return (
    <OverlayLabelContainer top={top}>
      <OverlayLabelText>{label || defaultLabel}</OverlayLabelText>
    </OverlayLabelContainer>
  );
};
